import { useMessageContext } from "provider/MessageProvider";
import { Link } from "react-router-dom";
import parse from 'html-react-parser';
import UserAvatar from "../common/UserAvatar";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatMessageTime1 } from "components/Api/common";

const Quatation = () => {
    const { quotationContact, activeUser, qcLoading, messageDispatch } = useMessageContext();

    const stripHtmlTags = (html) => {
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    };

    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) return text;
        return text.slice(0, maxLength) + "...";
    };

    return (
        <div className="chat-cardlist pt-3"

            style={{
                height: "78vh",
                overflowY: "auto",
                paddingTop: "6px",
                paddingBottom:'25px',
                position: "relative",

            }}
        >
            {qcLoading ? <div className="d-flex justify-content-center">
                <div
                    className="spinner-border loading-spinner"
                    role="status"
                >
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>

                :

                <>
                    {quotationContact?.map((item, index) => (
                        <div key={index}>
                            <Link
                                to="#"
                                id="user1"
                                className={`chat-link mb-3 d-block ${item?.contact?.user_handle === activeUser?.contact?.user_handle ? "active" : ""
                                    }`}
                                onClick={() => {
                                    const clickedUserHandle = item?.contact?.user_handle;
                                    const activeUserHandle = activeUser?.contact?.user_handle;
                                    messageDispatch({ type: `TOGGLE_CHAT_CONTACT`, payload: true });
                                    // Avoid resetting state if same user is clicked
                                    if (clickedUserHandle === activeUserHandle) return;
                                    messageDispatch({ type: "MESSAGE_SUMMARY", payload: {} });
                                    messageDispatch({ type: "SET_MESSAGES_DATA", payload: [], });
                                    messageDispatch({ type: "SET_MESSAGES_DATA", payload: [], });
                                    messageDispatch({ type: "MESSAGE_PAGE_INDEX", payload: 1, });
                                    messageDispatch({ type: "MESSAGE_INITIAL_PAGE_INDEX", payload: 1, });
                                    messageDispatch({ type: `SET_ACTIVE_USER`, payload: item });
                                }}
                            >
                                <div className="chat-sidebar-user-card click_mobile">
                                    <div className="d-flex gap-2 chat-user_message">
                                        <UserAvatar src={item?.contact?.profile_display_image} alt={item?.contact?.display_name} size={''} className="rounded-circle user-icon" />
                                        <div className="chat-user_name w-100">
                                            <div className="d-flex justify-content-between">
                                                <div
                                                    className="fs-6 mb-0 conatct-name"
                                                >
                                                    {item?.contact?.display_name}
                                                </div>
                                                {!item?.is_seen && <FontAwesomeIcon icon={faCircle} color="#bb3f3f" size='2xs' className="mt-1" />}
                                            </div>
                                            <p
                                                className={`mb-0 lastmassge conatct-message ${item?.is_seen ? '' : 'fw-bold'}`}
                                            >
                                                {item?.last_message &&
                                                    parse(
                                                        truncateText(stripHtmlTags(item?.last_message), 20)
                                                    )
                                                }

                                            </p>
                                            <div className="d-flex justify-content-end me-2">
                                                <span className={`m-0 message-time-contact`}>
                                                    Last Message: {formatMessageTime1(Number(item?.last_message_datetime))}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </>
            }
        </div>
    )
}

export default Quatation;